// ── 출퇴근 상태 뱃지 컴포넌트 ────────────────────────────────────────────────
import React from 'react';
import { STATUS_META } from './utils';

/**
 * 상태 뱃지 컴포넌트
 * @param {string}      status         - 상태 코드 (STATUS_META 키)
 * @param {boolean}     small          - 소형 표시 여부
 * @param {string|null} halfLeaveType  - 반차 유형 ('전반' | '후반' | null)
 */
export function StatusBadge({ status, small, halfLeaveType }) {
  const meta = STATUS_META[status] || STATUS_META.scheduled;
  // 반차 상태인 경우 반차(전)/반차(후) 구분 레이블로 표시
  const label = (status === 'half_leave' && halfLeaveType)
    ? `반차(${halfLeaveType})`
    : meta.label;

  return (
    <span style={{
      background: meta.bg,
      color: meta.text,
      border: `1px solid ${meta.border}`,
      borderRadius: 4,
      padding: small ? '1px 5px' : '2px 7px',
      fontSize: small ? 11 : 12,
      fontWeight: 600,
      whiteSpace: 'nowrap',
      display: 'inline-block',
    }}>
      {label}
    </span>
  );
}
